package us.laantech.laanmanage.feature.reports.tax.ui

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.Button
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.lifecycle.viewmodel.compose.viewModel
import androidx.lifecycle.viewmodel.initializer
import androidx.lifecycle.viewmodel.viewModelFactory
import us.laantech.common.ui.DateTimeEntryModal
import us.laantech.common.ui.DropdownMenu
import us.laantech.common.util.tryFormatAsDateTime
import us.laantech.laanmanage.feature.reports.z.ui.ReportCard

@Composable
fun TaxReportView(
    viewModel: TaxReportViewModel = viewModel(
        factory = viewModelFactory {
            initializer { TaxReportViewModel() }
        }
    )
) {
    val uiState by viewModel.uiState.collectAsStateWithLifecycle()
    LaunchedEffect(Unit) {
        viewModel.loadBranches()
        viewModel.loadReport()
    }

    Column {

        Row(modifier = Modifier.fillMaxWidth()) {
            // Select Store
            DropdownMenu(
                label = "Store",
                items = uiState.branches,
                selectedItem = uiState.selectedBranch,
                itemLabel = { it.branchName ?: "Unnamed Store" },
                onItemSelected = { branch -> viewModel.selectBranch(branch) },
                modifier = Modifier.weight(1f),
                noneLabel = "All Stores"
            )


            // Select time range
            Button({ viewModel.openFromDatePicker() }, Modifier.weight(1f)) {
                Text("From ${uiState.fromMillis.tryFormatAsDateTime()}")
            }

            Button({ viewModel.openToDatePicker() }, Modifier.weight(1f)) {
                Text("To ${uiState.toMillis.tryFormatAsDateTime()}")
            }
        }



        uiState.report?.let {
            ReportCard(it.sections.firstOrNull() ?: return@let)
        }
    }



    if (uiState.showFromDatePicker) {
        DateTimeEntryModal(
            initialEpochMillis = uiState.fromMillis,
            title = "Select Start Date",
            onDismiss = { viewModel.closeFromDatePicker() },
            onConfirm = { epochMillis ->
                viewModel.updateFromTime(epochMillis)
                viewModel.closeFromDatePicker()
            },
        )
    } else if (uiState.showToDatePicker) {
        DateTimeEntryModal(
            initialEpochMillis = uiState.toMillis,
            title = "Select End Date",
            onDismiss = { viewModel.closeToDatePicker() },
            onConfirm = { epochMillis ->
                viewModel.updateToTime(epochMillis)
                viewModel.closeToDatePicker()
            },
        )
    }



}